module.exports = __webpack_public_path__ + "static/txtling3-768x638-c953aef95559422b26f2563580eb6cfe.png";